import React from "react";

interface Props {
  editing: boolean;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
}

const ActionButtons: React.FC<Props> = ({
  editing,
  onEdit,
  onSave,
  onCancel,
}) => (
  <div className="flex justify-center gap-3 mt-6">
    {!editing ? (
      <button
        onClick={onEdit}
        className="bg-orangeBrand text-white px-4 py-2 rounded-md font-semibold hover:bg-orangeHover transition"
      >
        ✏️ Rediger
      </button>
    ) : (
      <>
        <button
          onClick={onCancel}
          className="bg-gray-300 text-textDark px-4 py-2 rounded-md font-semibold hover:bg-gray-400 transition"
        >
          ❌ Avbryt
        </button>
        <button
          onClick={onSave}
          className="bg-green-500 text-white px-4 py-2 rounded-md font-semibold hover:bg-green-600 transition"
        >
          💾 Lagre
        </button>
      </>
    )}
  </div>
);

export default ActionButtons;
